/* eslint-disable jira/filename-case */
import { getDocument } from '@jira/ssr__browser-globals/src/getDocument.tsx';

type MetaGetter = (name: string) => string | null;

type GlobalThisWithMetadataInSsr = typeof globalThis & { ssr__metadata?: Record<string, string> };

export const getMeta: MetaGetter = (name: string): string | null => {
	// In Jira SSR, we store metadata on globalThis so we read from there
	if (__SERVER__) {
		const globalThisWithMetadata: GlobalThisWithMetadataInSsr = globalThis;
		const value =
			globalThisWithMetadata.ssr__metadata && globalThisWithMetadata.ssr__metadata[name];
		return value !== undefined ? value : null;
	}

	// In Jira FE client, metadata is provided via `meta` tags in the document so we read from there
	const node = getDocument()?.querySelector(`meta[name="${name}"]`);
	const metaValue = node && node.getAttribute('content');
	return metaValue !== undefined ? metaValue : null;
};

export default getMeta;
